/**
 * OperatorLayout — 1등급 운영자(최고관리자) 콘솔. 플랫폼 전체(모든 학원·회원) god-mode.
 * 기존 /admin(구 단일학원 콘솔)과 완전 독립. 데스크탑 전용, 어두운 사이드바.
 * 게이트: superadmin adminSession (없으면 /admin/login).
 */
import React from 'react';
import { Outlet, useNavigate, useLocation, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { RxDashboard } from 'react-icons/rx';
import { HiOutlineBuildingStorefront, HiOutlineUsers } from 'react-icons/hi2';

const NAV = [
  { path: '/operator', label: '대시보드', icon: RxDashboard, end: true },
  { path: '/operator/academies', label: '학원 관리', icon: HiOutlineBuildingStorefront },
  { path: '/operator/members', label: '회원 관리', icon: HiOutlineUsers },
];

const OperatorLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const raw = localStorage.getItem('adminSession');
  if (!raw) return <Navigate to="/admin/login" replace />;
  let admin = {};
  try { admin = JSON.parse(raw); } catch {}
  if (admin.adminRole !== 'superadmin') return <Navigate to="/admin" replace />;

  return (
    <Container data-fullwidth>
      <Sidebar>
        <LogoArea onClick={() => navigate('/operator')}>
          <LogoIcon>1급</LogoIcon>
          <div>
            <LogoText>일등급 운영자</LogoText>
            <LogoSub>플랫폼 관리</LogoSub>
          </div>
        </LogoArea>
        <Nav>
          {NAV.map((item) => {
            const active = item.end ? location.pathname === item.path : location.pathname.startsWith(item.path);
            return (
              <NavItem key={item.path} $active={active} onClick={() => navigate(item.path)}>
                <item.icon size={18} />
                <span>{item.label}</span>
              </NavItem>
            );
          })}
        </Nav>
        <Footer>
          <FooterBtn onClick={() => { localStorage.removeItem('adminSession'); navigate('/admin/login'); }}>
            로그아웃
          </FooterBtn>
        </Footer>
      </Sidebar>
      <Main>
        <Content><Outlet /></Content>
      </Main>
    </Container>
  );
};

export default OperatorLayout;

const Container = styled.div` display: flex; min-height: 100vh; max-width: none !important; background: #F7F8FA; `;
const Sidebar = styled.aside`
  width: 240px; background: #15182A; color: #fff; flex-shrink: 0;
  position: fixed; top: 0; left: 0; bottom: 0; z-index: 10;
  display: flex; flex-direction: column;
`;
const LogoArea = styled.button`
  display: flex; align-items: center; gap: 11px; padding: 20px;
  border-bottom: 1px solid rgba(255,255,255,0.08); text-align: left;
`;
const LogoIcon = styled.div`
  width: 34px; height: 34px; border-radius: 9px; background: #4A7CFE; color: #fff;
  display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 800;
`;
const LogoText = styled.div` font-size: 15px; font-weight: 800; line-height: 1.1; `;
const LogoSub = styled.div` font-size: 11px; font-weight: 600; color: #8A90A6; margin-top: 2px; `;
const Nav = styled.nav` flex: 1; padding: 10px 8px; `;
const NavItem = styled.button`
  width: 100%; display: flex; align-items: center; gap: 11px; padding: 11px 14px; border-radius: 9px;
  color: ${({ $active }) => ($active ? '#fff' : '#A8AEC2')};
  background: ${({ $active }) => ($active ? 'rgba(74,124,254,0.22)' : 'transparent')};
  font-size: 14px; font-weight: ${({ $active }) => ($active ? 700 : 500)}; margin-bottom: 2px;
  &:hover { background: ${({ $active }) => ($active ? 'rgba(74,124,254,0.22)' : 'rgba(255,255,255,0.06)')}; color: #fff; }
`;
const Footer = styled.div` padding: 12px; border-top: 1px solid rgba(255,255,255,0.08); `;
const FooterBtn = styled.button`
  width: 100%; padding: 10px; border-radius: 8px; color: #8A90A6; font-size: 13px; font-weight: 600;
  &:hover { background: rgba(255,255,255,0.06); color: #fff; }
`;
const Main = styled.div` flex: 1; margin-left: 240px; display: flex; flex-direction: column; min-width: 0; `;
const Content = styled.main` flex: 1; padding: 28px; max-width: 1280px; width: 100%; `;
